import React from 'react';
import Header from '../components/layout/Header';
import Footer from '../components/layout/Footer';
import HeroSection from '../components/home/HeroSection';
import AboutSection from '../components/home/AboutSection';
import CaseTypesSection from '../components/home/CaseTypesSection';
import TestimonialsSection from '../components/home/TestimonialsSection';
import ResultsSection from '../components/home/ResultsSection';

const HomePage = () => {
  return (
    <div className="min-h-screen bg-white">
      <Header />
      <main>
        <HeroSection />
        <AboutSection />
        <CaseTypesSection />
        <TestimonialsSection />
        <ResultsSection />
      </main>
      <Footer />
    </div>
  );
};

export default HomePage;
